import React from 'react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white bg-opacity-95 shadow-sm" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="flex justify-center items-center h-16" data-id="element-116">
          <div className="flex-shrink-0 flex items-center" data-id="element-117">
            <a href="#" className="flex items-center" data-id="element-118">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iqPLuF8HywbTKSGMEqnRhB/Design_sans_titre_%283%29.png" alt="Materrea Logo" className="h-10 w-auto" data-id="element-119" />
            </a>
          </div>
        </div>
      </div>
    </nav>;
}